import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-828125a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-location" }
const _hoisted_2 = { class: "uf-location__body" }
const _hoisted_3 = { class: "uf-location__info" }
const _hoisted_4 = { class: "uf-button" }
const _hoisted_5 = { class: "uf-button--footer" }
const _hoisted_6 = { class: "uf-stores__body" }
const _hoisted_7 = { class: "uf-stores__info" }
const _hoisted_8 = { class: "uf-stores__item-label van-ellipsis" }
const _hoisted_9 = { class: "popover-inner" }
const _hoisted_10 = { class: "uf-button" }
const _hoisted_11 = { class: "uf-button--footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_uf_tree = _resolveComponent("uf-tree")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popover = _resolveComponent("van-popover")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: _ctx.popupShow,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.popupShow) = $event)),
      position: "right",
      style: { height: '100%', width: '100%' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_nav_bar, {
            title: "选择部门",
            "left-text": "返回",
            "left-arrow": "",
            onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.popupShow = false))
          }),
          (_ctx.data.length === 0)
            ? (_openBlock(), _createBlock(_component_van_search, {
                key: 0,
                modelValue: _ctx.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event)),
                shape: "round",
                placeholder: "搜索",
                onSearch: _ctx.onSearch
              }, null, 8, ["modelValue", "onSearch"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.data.length > 0)
              ? (_openBlock(), _createBlock(_component_uf_tree, {
                  key: 0,
                  data: _ctx.data,
                  ref: "ufTreeRef"
                }, null, 8, ["data"]))
              : (_openBlock(), _createBlock(_component_uf_tree, {
                  key: 1,
                  data: _ctx.departmentStore,
                  ref: "ufTreeRef"
                }, null, 8, ["data"]))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.multiple)
                ? (_openBlock(), _createBlock(_component_van_button, {
                    key: 0,
                    plain: "",
                    class: "btn",
                    square: "",
                    type: "primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showCheckedList = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("已选 " + _toDisplayString(_ctx.checkedList.length), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_van_button, {
                block: "",
                class: "btn",
                color: "#3d6eeb",
                square: "",
                type: "success",
                onClick: _ctx.getPlaceInfo
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认 ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showCheckedList,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showCheckedList) = $event)),
      position: "right",
      style: { height: '100%', width: '100%' },
      onOpened: _ctx.opened
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_van_nav_bar, {
            title: "已选位置",
            "left-text": "返回",
            "left-arrow": "",
            onClickLeft: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showCheckedList = false))
          }),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_van_cell_group, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkedList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_van_cell, {
                    class: "active",
                    clickable: "",
                    center: "",
                    key: item.id
                  }, _createSlots({
                    icon: _withCtx(() => [
                      _createVNode(_component_van_checkbox, {
                        modelValue: _ctx.showCheckedList,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showCheckedList) = $event)),
                        style: {"margin-right":"10px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    title: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(item.true_department), 1),
                      _createElementVNode("div", {
                        class: "uf-stores__item-label uf-stores__item-label-hidden",
                        ref_for: true,
                        ref: el => _ctx.addCheckedPlaceRef(el, index)
                      }, _toDisplayString(item.true_department), 513)
                    ]),
                    _: 2
                  }, [
                    (_ctx.checkedPlacePopover[index])
                      ? {
                          name: "right-icon",
                          fn: _withCtx(() => [
                            _createVNode(_component_van_popover, {
                              show: item.showPopover,
                              "onUpdate:show": ($event: any) => ((item.showPopover) = $event),
                              placement: "bottom-end"
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_van_icon, {
                                  name: "info",
                                  color: "#3d6eeb",
                                  size: "24"
                                })
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, _toDisplayString(item.true_department), 1)
                              ]),
                              _: 2
                            }, 1032, ["show", "onUpdate:show"])
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_van_button, {
                plain: "",
                class: "btn",
                square: "",
                type: "primary",
                onClick: _ctx.clear
              }, {
                default: _withCtx(() => [
                  _createTextVNode("清空 ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_van_button, {
                class: "btn",
                color: "#3d6eeb",
                square: "",
                type: "success",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showCheckedList = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认 ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "onOpened"])
  ]))
}